module.exports = __webpack_public_path__ + "static/media/secondmenu.9b4b7792.mp3";